import { render, staticRenderFns } from "./PaymentOrderChangeRegionLayout.vue?vue&type=template&id=20e59c92&scoped=true&lang=pug&"
import script from "./PaymentOrderChangeRegionLayout.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderChangeRegionLayout.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrderChangeRegionLayout.vue?vue&type=style&index=0&id=20e59c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e59c92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VIcon,VLayout})
